module.exports = __webpack_public_path__ + "static/media/microsoft-excel.dfd66319.png";